var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg9B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "matrix(1 0 0 1 0 -987.362121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path3336"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.66,
    fill: "none",
    stroke: "#000000",
    d: "M0.94 1019.86 C0.94 1002.53 15.14 988.46 32.62 988.46 C50.11 988.46 64.31 1002.53 64.31 1019.86 C64.31 1037.18 50.11 1051.25 32.62 1051.25 C15.14 1051.25 0.94 1037.18 0.94 1019.86 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3338"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.17,
    fill: "#ffffff",
    fillRule: "evenodd",
    stroke: "#000000",
    d: "M15.62 1018.95 C15.62 1010.22 23.09 1003.13 32.27 1003.13 C41.46 1003.13 48.92 1010.22 48.92 1018.95 C48.92 1027.69 41.46 1034.78 32.27 1034.78 C23.09 1034.78 15.62 1027.69 15.62 1018.95 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tspan3344",
    transform: "matrix(1.013154 0 0 0.987017 24.940939 1005.552734)"
  }, /*#__PURE__*/React.createElement("text", {
    kerning: 0,
    fontFamily: ".AppleSystemUIFont",
    fontWeight: 700,
    fontSize: 22.1
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21.37
  }, "9"))), /*#__PURE__*/React.createElement("g", {
    id: "a4153",
    transform: "matrix(0.658461 0 0 0.654771 -0.609232 987.251831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path3349"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.01,
    fill: "#0000ff",
    stroke: "#000000",
    d: "M15.88 16.46 L85.3 16.46"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "path3351"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.66,
    fill: "none",
    stroke: "#000000",
    d: "M8.17 1039.75 L57.23 1039.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path4158"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffff00",
    d: "M7.18 1038.32 C4.18 1034.26 2.16 1029.39 1.38 1024.3 C1.06 1022.17 1.05 1017.46 1.38 1015.42 C2.37 1009.18 4.88 1003.82 8.96 999.2 L9.7 998.37 L32.7 998.43 L55.7 998.5 L56.74 999.72 C59.5 1002.96 61.77 1007.16 62.97 1011.31 C64.84 1017.71 64.48 1025.04 62.01 1031.26 C61.11 1033.51 59.39 1036.58 58.05 1038.33 L57.43 1039.13 L39.87 1039.19 C30.22 1039.23 19.09 1039.29 15.15 1039.33 L7.98 1039.4 L7.18 1038.32 Z M34.9 1034.71 C36.75 1034.43 38.29 1033.94 40 1033.1 C41.82 1032.2 42.97 1031.38 44.4 1029.96 C47.43 1026.95 49.01 1023.19 49.02 1018.97 C49.02 1014.84 47.57 1011.22 44.69 1008.24 C41.07 1004.5 36.14 1002.66 30.84 1003.07 C29.29 1003.19 27.2 1003.66 25.87 1004.18 C21.37 1005.95 17.74 1009.72 16.26 1014.15 C15.24 1017.21 15.29 1021.08 16.39 1024.14 C17.95 1028.44 21.45 1031.97 25.89 1033.72 C26.94 1034.14 28.64 1034.58 29.81 1034.75 C31.04 1034.93 33.57 1034.91 34.9 1034.71 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3350",
    transform: "matrix(1 0 0 1 0 987.362121)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M29.43 63.32 C27.67 63.13 23.82 62.25 22.15 61.65 C18.11 60.2 13.91 57.59 10.94 54.7 L9.17 52.98 L20.71 52.81 C27.06 52.71 37.66 52.66 44.27 52.69 L56.28 52.74 L54.68 54.34 C49.08 59.93 41.67 63.1 33.67 63.32 C31.86 63.37 29.95 63.37 29.43 63.32 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3352",
    transform: "matrix(1 0 0 1 0 987.362121)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M12.23 9.12 C15.72 5.92 20.98 3.32 26.31 2.18 C29.74 1.44 35.48 1.44 38.91 2.18 C44.29 3.33 49.2 5.77 53.34 9.34 L54.37 10.23 L32.71 10.22 L11.06 10.21 L12.23 9.12 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3439",
    transform: "matrix(1 0 0 1 0 987.362121)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M29.31 63.32 C22.27 62.44 15.6 59.28 10.7 54.49 L9.17 53 L20.6 52.81 C26.88 52.71 37.48 52.66 44.15 52.69 L56.28 52.74 L54.66 54.35 C48.93 60.03 41.71 63.1 33.55 63.33 C31.67 63.38 29.77 63.37 29.31 63.32 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9B);
export default __webpack_public_path__ + "static/media/9B.53c4cd63eee5b0e5e9c31ac22db437e5.svg";
export { ForwardRef as ReactComponent };